import {Component, Inject, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {FormService} from '@services/form.service';
import {AlertService} from '@services/alert.service';
import {Favorite, FavoriteList} from '@models/favorite';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-order-list-popup',
  templateUrl: './order-list-popup.component.html',
  styleUrls: ['./order-list-popup.component.scss']
})
export class OrderListPopupComponent implements OnInit {

    loading = false;
    listFavorite: FavoriteList[];

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        public dialogRef: MatDialogRef<OrderListPopupComponent>,
        public formService: FormService,
        private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.listFavorite = this.data.listFavorite;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.loading = true;
        this.adService.sortFavoritesList(this.listFavorite).subscribe(() => {
            this.loading = false;
            this.dialogRef.close(true);
        }, error => {
            this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
            console.log(error);
            this.loading = false;
        });
    }

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(this.listFavorite, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(this.listFavorite,
                [],
                event.previousIndex,
                event.currentIndex);
        }
    }

}
